import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  background: {
    backgroundColor: "$background",
  },
  card: {
    backgroundColor: "$survey_card",
  },
  contentContainer: {
    flex: 1,
    alignSelf: "center",
    alignItems: "center",
  },
  headerContainer: {
    marginTop: "3vh",
    flexDirection: "row",
    justifyContent: "center",
  },
  finishSurvey: {
    position: "absolute",
    right: 0,
    top: "4vh",
  },
  finishSurveyText: {
    color: "$help_text",
    fontSize: "$finish_survey_text_size",
    fontFamily: "$finish_survey_text_style",
  },
  logo: {
    alignSelf: "flex-end",
    width: "$width_logo",
    height: "$height_logo",
  },
  button: {
    marginTop: "2vh",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  buttonText: {
    fontWeight: "bold",
    color: "$question_text",
  },
  section: {
    marginBottom: "3vh",
    alignItems: "center",
  },
  modal: {
    paddingVertical: "3vh",
    paddingHorizontal: "3vw",
    backgroundColor: "$survey_card",
  },
  slider: {
    justifyContent: "center",
    height: "100%",
    width: "100%",
  },
  quizButton: {
    color: "$survey_card",
    backgroundColor: "$question_text",
  },
});
